const defaultFallbackImage = require('Assets/ambileap_logo.svg?dataurl');

function applyFallback(el, binding) {
  if (el.nodeName !== 'IMG') {
    return;
  }
  try {
    const errorImage = typeof binding.value === 'string' ? binding.value : defaultFallbackImage;
    const src = el.src;

    const img = new Image();
    img.src = src;
    img.onload = () => {
      el.src = src;
    };
    img.onerror = () => {
      el.src = errorImage;
      el.style['object-fit'] = 'contain';
    };
  } catch (e) {
    console.error(e);
  }
}

export default {
  bind(el, binding) {
    applyFallback(el, binding);
  },
  update(el, binding) {
    applyFallback(el, binding);
  },
};
